import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { VertriebsType } from './vertriebstype.enum';
import { Wettbewerber } from '../entities/schema/wettbewerber.entity';
import { WettbewerberPreis } from '../entities/wettbewerb/wettbewerberpreis.entity';
//#endregion

@Injectable()
export class WettbewerberService extends ODataEntityService<Wettbewerber> {
  constructor(protected client: ODataClient) {
    super(client, 'Wettbewerber', 'entities.schema.Wettbewerber');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public wettbewerberpreise(entity: EntityKey<Wettbewerber>): ODataNavigationPropertyResource<WettbewerberPreis> {
    return this.entity(entity).navigationProperty<WettbewerberPreis>('wettbewerberpreise');
  }
  //#endregion
}
